import { SecureRoute } from '@okta/okta-react';
import React, { FC, useMemo } from 'react';
import { Switch, useRouteMatch } from 'react-router';
import { PageLoading } from 'components/atoms/loading';
import {
  TimesheetCategoryWiseReport,
  TimesheetOverallReport,
  TimesheetPeopleWiseReport,
  TimesheetProjectWiseReport,
} from 'components/pages/timesheet-reports';
import {
  asMasterList,
  useCategories,
} from 'components/pages/timesheet-settings/categories';
import { from } from 'components/pages/timesheet-settings/categories/core';
import { useConfiguration } from 'components/pages/timesheet-settings/use-configuration';

export const TimesheetsReportRoute: FC = () => {
  const { path } = useRouteMatch();
  const { categories: _categories } = useCategories();
  const categories = useMemo(
    () => asMasterList(_categories).map(([_, x]) => x),
    [_categories],
  );

  const [configuration] = useConfiguration();

  return from(_categories).ids[0] === 'just' && configuration[0] === 'just' ? (
    <Switch>
      <SecureRoute path={`${path}/projects/:projectId`}>
        <TimesheetProjectWiseReport
          timesheetCategories={categories}
          configuration={configuration[1]}
        />
      </SecureRoute>
      <SecureRoute path={`${path}/users/:userId`}>
        <TimesheetPeopleWiseReport
          timesheetCategories={categories}
          configuration={configuration[1]}
        />
      </SecureRoute>
      <SecureRoute path={`${path}/categories/:categoryId`}>
        <TimesheetCategoryWiseReport
          timesheetCategories={categories}
          configuration={configuration[1]}
        />
      </SecureRoute>
      <SecureRoute path={`${path}`}>
        <TimesheetOverallReport
          timesheetCategories={categories}
          configuration={configuration[1]}
        />
      </SecureRoute>
    </Switch>
  ) : (
    <PageLoading />
  );
};
